export const SELECT_PROFILE_CONTAINER_DATA = 'SELECT_PROFILE_CONTAINER_DATA';
export const START_PROFILE_CONTAINER_LOAD = 'START_PROFILE_CONTAINER_LOAD';
export const FINISH_PROFILE_CONTAINER_LOAD = 'FINISH_PROFILE_CONTAINER_LOAD';
export const SELECT_PROFILE_CONTAINER_DATA_ATTRIBUTE = 'profileContainer';
export const RESET_PROFILE_CONTAINER_DATA = 'RESET_PROFILE_CONTAINER_DATA';
